import React from "react";
import { Icon } from "../../Layout/Icon/Icon";

export interface MicrophoneButtonProps {
  isMicEnabled: boolean;
  isMicListening: boolean;
  toggleMic: () => void;
  isProcessingAudio?: boolean;
}

export const MicrophoneButton: React.FunctionComponent<MicrophoneButtonProps> =
  ({ isMicEnabled, toggleMic, isMicListening, isProcessingAudio }) => (
    <div className="microphone-button__wrapper">
      <button
        className={
          `button content-dialog__button 
          ${isMicEnabled ? "content-dialog__button--enabled" : ""}
          ${isMicListening && !isProcessingAudio ? "pulse" : ""}
          ${isProcessingAudio ? "processing" : ""}`
        }
        aria-label={isProcessingAudio ? "Processing audio" : "Allow microphone"}
        onClick={toggleMic}
        disabled={isProcessingAudio}
      >
        {isProcessingAudio ? (
          <div className="spinner" />
        ) : (
          <Icon
            name="mic"
            stroke="#F9DDD2"
            fill="#F9DDD2"
            size={21}
            height={40}
          />
        )}
      </button>
    </div>
  );
